import React from 'react';
import ReactDOM from 'react-dom/client';
import './css/index.css';
import './css/App.css';
import App from './App';
import { BrowserRouter } from 'react-router-dom';
import DataContext from './context/DataContext';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
    <DataContext >
        <BrowserRouter>
            <App />
        </BrowserRouter>
    </DataContext>

);



